import { GRID_ACTIONS_COLUMN_TYPE } from '@mui/x-data-grid';
import type { GridColDef } from '@mui/x-data-grid-pro';
import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GRID_TREE_DATA_GROUPING_FIELD,
} from '@mui/x-data-grid-pro';

const NON_TOGGLABLE_COLUMNS_DEFAULT = [
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GRID_TREE_DATA_GROUPING_FIELD,
  GRID_ACTIONS_COLUMN_TYPE,
];

/**
 * Remove columns from columns panel and prevent them from being toggleable.
 * Removes by default the following columns: checkbox selection, detail panel, tree data grouping and actions.
 *
 * The prop `hideable: false` needs to be set in each column definition to also disable the toggle inside the column header.
 *
 * If the actions column is set, make sure the type is `actions` or add the hideable prop and set it to false in your column definition.
 */
export const initTogglableColumns = (
  nonTogglableColumns: GridColDef['field'][] = [],
) => {
  return (columns: GridColDef[]) =>
    columns.reduce(
      (acc, column) => {
        if (
          ![...NON_TOGGLABLE_COLUMNS_DEFAULT, ...nonTogglableColumns].includes(
            column.field,
          )
        ) {
          acc.push(column.field);
        }

        return acc;
      },
      [] as GridColDef['field'][],
    );
};

export const getTogglableColumnsDefault = initTogglableColumns();
